import {Store} from "seu-frontend/store"
import {onError} from "apollo-link-error";
import {ApolloLink, Observable} from "apollo-link";
import {HttpLink} from "apollo-link-http";
import fetch from "node-fetch";
import {createUploadLink} from "apollo-upload-client";

const createApolloLink = function (Store) {
  let uri = 'http://localhost:3000/';

  if (process.env.NODE_ENV === 'production') {
    uri = '/graphql'
  }

  if (process.env.VUE_APP_API_URL) {
    uri = process.env.VUE_APP_API_URL
  }

  const httpLink = new HttpLink({
    // You should use an absolute URL here
    uri,
    fetch: fetch
  });

  return new ApolloLink((operation, forward) => {
    let headers = {
      lang: Store.state.currentLanguage
      // 'x-app-id': '5f384e80-9017-4945-9f7f-bcd2f9e7b79c'
    };

    // if (Store.state.auth && Store.state.auth.accessToken) {
    //   headers = {
    //     ...headers,
    //     authorization: Store.state.auth.accessToken
    //   }
    // }
    operation.setContext({
      headers
    });
    return forward(operation);
  }).concat(httpLink)


}

const link = createApolloLink(Store)

export default link

